import { render, staticRenderFns } from "./PromocodeDataTable.vue?vue&type=template&id=3d4ca864&"
import script from "./PromocodeDataTable.vue?vue&type=script&lang=js&"
export * from "./PromocodeDataTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VPagination } from 'vuetify/lib/components/VPagination';
installComponents(component, {VDataTable,VPagination})


/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d4ca864')) {
      api.createRecord('3d4ca864', component.options)
    } else {
      api.reload('3d4ca864', component.options)
    }
    module.hot.accept("./PromocodeDataTable.vue?vue&type=template&id=3d4ca864&", function () {
      api.rerender('3d4ca864', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ShopSetting/Pages/Promocode/components/PromocodeDataTable.vue"
export default component.exports